export default __webpack_public_path__ + "static/media/AnimalMondey01_06.5be58113.png";